import { put, call, takeEvery } from 'redux-saga/effects';
import { getUserProfile } from '../../../requests/user_profile_requests/get_user_profile_request';
import { removeUserProfileGroupsList } from '../../../requests/user_profile_groups_requests/remove_groups_list';
import { clearUsersCacheRequest } from '../../../../User_create/requests/clear_users_cache';
import { USER_PROFILE_GROUPS_REMOVE_REQUEST } from '../../constants/user_profile_groups.constants';
import { userProfileGroupsRemoveSuccess, userProfileGroupsRemoveFailure } from '../../actions/user_profile_groups_actions/user_profile_groups_remove.actions';
import { message_success, message_error } from '../../../../../../components/Message';
import { getErrorMessage } from '../../../../../../shared/helpers';

function* userProfileGroupsRemoveRequest({ user_id, del_groups }) {
    try {
        const { result, msg, error } = yield call(removeUserProfileGroupsList, user_id, del_groups);
        if (result) {
            const profile = yield call(getUserProfile, user_id);
            yield put(userProfileGroupsRemoveSuccess(profile.options.groups));
            message_success('User Group Removed Successfully!');

            yield call(clearUsersCacheRequest);
        } else {
            yield put(userProfileGroupsRemoveFailure(error));
            message_error(msg);
        }
    } catch (error) {
        message_error(getErrorMessage(error));
    }
}

export default function* userProfileGroupsRemoveSaga() {
    yield takeEvery(USER_PROFILE_GROUPS_REMOVE_REQUEST, userProfileGroupsRemoveRequest);
}



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/sagas/user_profile_groups_sagas/user_profile_groups_remove.saga.js